// import { InventoryList } from '@/services/MockData/InventoryList/Inventory'
import { HTTP_METHODS } from '@/utils/constants/httpMethods'
import { API_VERSION } from '@/utils/constants/commonConstants'
import { InventoryUploadHistoryData } from '@/services/MockData/InventoryList/InventoryUploadHistoryData'


export const INVENTORY_CONFIG = {
  INVENTORY: (queryParams) => ({
    endPoint: 'inventory?' + queryParams,
    // mockData: InventoryList,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use PRODUCTS_API_URL
    method: HTTP_METHODS.POST,
  }),
  INVENTORY_CSV_DOWNLOAD: (queryParams) => ({
    endPoint: 'inventory/download?' + queryParams,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
  INVENTORY_UPLOAD_HISTORY: {
    endPoint: 'inventory/upload-history',
    mockData: InventoryUploadHistoryData,
    // baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    version: API_VERSION.V1,
  },
}